module.exports = __webpack_public_path__ + "img/lessonpre_arrow_up_blue.cc53834d.svg";